/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useDtfStore } from "../store";
import { cn } from "tailwind-variants";
import "./Styles.scss";
import { renderList } from "common/vue/render-list";

export default function Styles({ ...restProps }) {
  const styles = [
    {
      label: "Straight",
      value: "straight"
    },
    {
      label: "Vertical",
      value: "vertical"
    }
  ];
  const store = useDtfStore();

  function letterNumberArtwork() {
    // @ts-expect-error TS(4111): Property 'letterNumberArtwork' comes from an index... Remove this comment to see the full error message
    return store.letterNumberArtwork;
  }

  function handleSelect(option: any) {
    const style = option.value;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      style
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateAllLetterPreviews();
  }

  return (
    // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
    <div {...restProps} className={cn("styles", restProps.className)}>
      {renderList(styles, style => (
        <div
          className={cn(
            "styles__item",
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            style.value === letterNumberArtwork().style && "styles__item--selected"
          )}
          key={style.value}
          onClick={() => {
            handleSelect(style);
          }}
          data-testid="styles-div"
        >
          <div className={cn("styles__text-preview", `styles__text-preview--${style.value}`)}>
            <img
              className={cn("styles__image", `styles__image--${style.value}`)}
              src={`https://jiffy.imgix.net/gen/letters-pdp/${style.value}.png`}
              alt={style.label}
            />
          </div>
          <div className="styles__label">{style.label}</div>
        </div>
      ))}
    </div>
  );
}
